<template>
  <div class="register auth-view">
    <div class="form-wrap">
      <MainLogo/>
      <form @submit="submitForm" class="form" autocomplete="false">
        <!-- TODO добавить переводы -->
        <app-text-input v-for="(field, key, i) in registerInputs"
          :key="i"
          v-model="field.value"
          :label="field.label"
          :type="field.type"
          :required="true"
          :validate="saveFlag"
          :errorMsg="'Not valid field ' + field.label"
          :group="1"
          @validateEnv="save"
        />

        <app-sel
          v-model="country"
          filterable
          :label="this.$ml.get('Сountry')"
          :items="countries"
          is-object
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              {{ item.label }}
            </app-sel-opt>
          </template>
        </app-sel>

        <div class="buttons">
          <app-btn :to="'/auth/login'" styling="outline">{{ $ml.get(`cancel`) }}</app-btn>
          <app-btn type="submit">{{ $ml.get(`Sign Up!`) }}</app-btn>
        </div>

      </form>

    </div>
  </div>
</template>


<script>
import API from '@/api'
import MainLogo from '@/components/auth/MainLogo';

// TODO добавить переводы в registerInputs > label
export default {
  data() {
    return {
      role : this.$route.params.role,
      refUserId : this.$route.params.refUserId,
      registerInputs : {
        firstName : {
          label : 'Fullname',
          type  : 'text',
          value : null,
          required : true,
          autocomplete : false,
          maxlength : 20,
          minlength : 2,
        },
        email : {
          label : this.$ml.get('Email'),
          type  : 'email',
          value : null,
          required : true,
          autocomplete : false,
          maxlength : 40,
          minlength : 5,
        },
        password : {
          label : 'Password',
          type  : 'password',
          value : null,
          required : true,
          autocomplete : false,
          maxlength : 20,
          minlength : 6,
        },
        confirmPassword : {
          label : this.$ml.get('Confirm Password'),
          type  : 'password',
          value : null,
          required : true,
          autocomplete : false,
          maxlength : 20,
          minlength : 6,
        },
        phone : {
          label : 'Phone number',
          type  : 'text',
          value : null,
          required : true,
          autocomplete : false,
          maxlength : 20,
        },
        // country : {
        //   label : 'Country Name',
        //   type  : 'text',
        //   value : null,
        //   required : false,
        //   autocomplete : false,
        //   maxlength : 40,
        // },
        // companyName : {
        //   label : 'Company Name',
        //   type  : 'text',
        //   value : null,
        //   required : false,
        //   autocomplete : false,
        //   maxlength : 40,
        // },
      },
      country: {
        frameLabel : this.$ml.get('Country')
      },
      saveFlag: false
    }
  },

  methods : {
    save (flag) {
      console.log(flag);
      if (!flag)
        return;

      let request = {
        firstName : this.registerInputs.firstName.value,
        lastName : this.registerInputs.firstName.value,
        password : this.registerInputs.password.value,
        email : this.registerInputs.email.value,
        // company : this.registerInputs.companyName.value,
        phone : this.registerInputs.phone.value,
        country : this.country.value,
        accountType : this.role,
        companyId : this.refUserId,
      }
      if(request.password != this.registerInputs.confirmPassword.value) {
        this.$notify({
          group: 'notices',
          title: "Passwords doesn't match",
          type : 'error',
        });
      }else {
        return API.auth.createUser(request).then(res => {
          API.auth.login({
            email: request.email,
            password: request.password,
          }).then(res => {
            this.$store.commit('user/auth', res.data.access_token);
            this.$store.dispatch('user/updateData').then(() => {
              this.$router.push('/auth/after-register');
            });
          }).catch(err => {
              this.$notify({
                group: 'notices',
                title: this.$ml.get(`Wrong password or email`),
                type : 'error',
              });
          });
        }).catch(err => {
          console.log(err.response.data.err);
          for(let errorMessage in err.response.data.err) {
            this.$notify({
              group: 'notices',
              title: `${err.response.data.err[errorMessage]}`,
              type : 'error',
            });
          }
        });
      }
    },
    submitForm(e) {
      e.preventDefault();

      this.saveFlag = !this.saveFlag;

      // let request = {
      //   firstName : this.registerInputs.firstName.value,
      //   lastName : this.registerInputs.firstName.value,
      //   password : this.registerInputs.password.value,
      //   email : this.registerInputs.email.value,
      //   // company : this.registerInputs.companyName.value,
      //   phone : this.registerInputs.phone.value,
      //   country : this.country.value,
      //   accountType : this.role,
      //   companyId : this.refUserId,
      // }
      // if(request.password != this.registerInputs.confirmPassword.value) {
      //   this.$notify({
      //     group: 'notices',
      //     title: 'Passwords doesn\'t match',
      //     type : 'error',
      //   });
      // }else {
      //   return API.auth.createUser(request).then(res => {
      //     API.auth.login({
      //       email: request.email,
      //       password: request.password,
      //     }).then(res => {
      //       this.$store.commit('user/auth', res.data.access_token);
      //       this.$store.dispatch('user/updateData').then(() => {
      //         this.$router.push('/auth/after-register');
      //       });
      //     }).catch(err => {
      //         this.$notify({
      //           group: 'notices',
      //           title: this.$ml.get(`Wrong password or email`),
      //           type : 'error',
      //         });
      //     });
      //   }).catch(err => {
      //     console.log(err.response.data.err);
      //     for(let errorMessage in err.response.data.err) {
      //       this.$notify({
      //         group: 'notices',
      //         title: `${err.response.data.err[errorMessage]}`,
      //         type : 'error',
      //       });
      //     }
      //   });
      // }

    }
  },

  computed: {
    countries() {
      return this.$store.getters['countries/data'];
    }
  },

  created() {



    if(!this.role) {
      this.$router.replace({ name: 'select-role' })
    }
  },

  components: {
    MainLogo,
  },
}
</script>

<style lang="scss" scoped>
.register {

  .form-wrap {

    form {
      width: 600px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .form-group {
        flex-basis: calc(50% - 12px);
      }
      .checkboxes {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .column {
          display: flex;
          flex-direction: column;
          > a { font-size:14px; }
          label {
            font-size: 16px;
            span {
              color: #9F9F9F;
              user-select: none;
              display: flex;
              flex-direction: row;
              margin-bottom: 4px;
              font-size: 14px;
              align-items: center;
              a {
                padding-left: 4px;
              }
              i:before {
                content: 'check_box_outline_blank';
                padding-right: 8px;
              }
            }
            input[type="checkbox"] {
              display:none;
              &:checked + span i {
                &:before {
                  content: 'check_box';
                  padding-right: 8px;
                }
              }
            }
          }
        }
      }
      @media(max-width: 768px) {
        width: 100%;
        flex-direction: column;
        flex-wrap: unset;
        > * {
          flex-basis: 100%;
          width: 100%;
        }
      }
    }
    .buttons {
      width: 600px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 32px;
      .a-btn {
        flex-basis: calc(50% - 6px);
        // display: block;
        padding: 8px 32px;
        text-align: center;
        font-size: 18px;
        margin-top: 16px;
      }
      @media(max-width: 768px) {
        width: 100%;
      }
    }
  }



  &#content {
    // flex-direction: column;
  }
  .header {
    text-align: center;
    margin: 20px 0;
  }
  .form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > *:not(.buttons){
      margin: 10px 0 24px;
      flex-basis: calc(50% - 16px);
    }
  }
  @media (max-width:900px) {
    &#content {
      display: block;
      .login-image {
        display: none;
      }
      .login-form {
        padding: 0 12px;
        .form, .logo {
          width: 100%;
          margin-bottom: 8px;
          .checkboxes {
            flex-direction: column;
            .column > a {
              // text-align: right;
            }
          }
          .form-group {
            flex-basis: 100%;
          }
        }
        .buttons {
          flex-direction: column-reverse;
          flex-wrap: nowrap;
          width: 100%;
          > .a-btn {
            text-align: center;
            margin-bottom: 16px;
            margin-top: 0;
            padding: 8px 12px;
            line-height: 24px;
            font-size: 24px;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
